export default __webpack_public_path__ + "static/media/bgcgm_joydrive2020_mcp_1684.da06d205.jpg";